// ----------------
// Axes translators
// ----------------

const ORDERED_AXIS_COLORS = ["green", "yellow", "red", "blue"];

// "yellow" -> 2
function getAxisNumberFromColor(axisColor) {
  const result = ORDERED_AXIS_COLORS.indexOf(axisColor);
  return result != -1 ? result + 1 : -1;
}

// magic
function getAxisNumber(anyAxisRepr) {
  function getAxisNumberFromLetter(axisCoord) {
    const axis = ["x", "y", "z", "w"].indexOf(axisCoord.toLowerCase());
    return axis != -1 ? axis + 1 : -1;
  }

  if (typeof anyAxisRepr === 'string' && /^[1234]$/.test(anyAxisRepr)) { anyAxisRepr = parseInt(anyAxisRepr, 10); }

  if (typeof anyAxisRepr === 'number') {
    if (anyAxisRepr >= 1 && anyAxisRepr <= 4) {
      return anyAxisRepr;
    } else {
      console.error("axis must be between 1 and 4");
    }
  } else if (typeof anyAxisRepr === 'string') {
    if (["x", "y", "z", "w"].includes(anyAxisRepr.toLowerCase())) {
      return getAxisNumberFromLetter(anyAxisRepr);
    } else if (ORDERED_AXIS_COLORS.includes(anyAxisRepr)) {
      return getAxisNumberFromColor(anyAxisRepr);
    } else {
      console.error(`axis must be one of "x", "y", "z", "w", ${ORDERED_AXIS_COLORS.map(axisColorStr => `"${axisColorStr}"`).join(", ")}`);
    }
  } else {
    console.error("axis must be a string or a number");
    console.log(anyAxisRepr);
  }
}

// return an object with methods to convert the given axis representation to the corresponding axis representation.
// conversion is lazy
function convert(anyAxisRepr) {
  function getAxisColorFromNumber(axis) {
    return axis >= 1 && axis <= 4 ? ORDERED_AXIS_COLORS[axis - 1] : -1;
  }

  function getAxisLetterFromNumber(axis) {
    if (axis === 1) { return "x"; }
    else if (axis === 2) { return "y"; }
    else if (axis === 3) { return "z"; }
    else if (axis === 4) { return "w"; }
    else { return "Axis Error"; }
  }

  const axisNumber = getAxisNumber(anyAxisRepr);

  return {
    toColor: () => getAxisColorFromNumber(axisNumber),
    toNumber: () => axisNumber,
    toLetter: () => getAxisLetterFromNumber(axisNumber)
  };
}
// -------------------
// String Manipulators
// -------------------

/**
 * ['1', '2', '3', '4'] -> '1, 2, 3, and 4'
 * ['1', '2'] -> '1 and 2'
 * ['1'] -> '1'
 */
function punctuate(arr) {
  if (arr.length <= 2) { return arr.join(" and "); }
  const last = arr.pop();
  return arr.join(", ") + ", and " + last;
}

function capitalize(title){
  return title.charAt(0).toUpperCase() + title.slice(1);
}


// ----------------
// Loops and Arrays
// ----------------

/**
 * loopedCb: (repeat: () => void) => any) => any
 * is the function that will be repeated after a certain delay, it is called with the cb repeat as an argument. The looped cb function can call the repeat cb to trigger the looped cb function to be called again after a delay has elapsed.
 *
 * options: { delay: number }
 *  - delay is the target delay, and the guaranteed minimum interval that will elapse between two consecutive calls to the loopedCb function. The real delay that occurs between two consecutive calls may exceed the target delay, as the looped cb function can take longer to call the repeat cb than the given delay.
 */
function loop(loopedCB, options = {}) { // buffer and filter dupe retries
  let delay = 0; // ms // this is the target, in reality the function can end up being called after the delay (if the loopedCb takes longer to call the repeat cb)
  delay = options.hasOwnProperty("delay") ? options.delay : delay;

  function repeat() {
    const correctedDelay = delay - (Date.now() - lastCallTimestamp); // the delay less how much time it took between the loopedCb being called, and it calling the repeat cb (now)
    setTimeout(() => {
      lastCallTimestamp = Date.now();
      loopedCB(repeat);
    }, correctedDelay); // significantly more accurate (so long as the single threaded code runtime of loopedCb does no exceed the delay)
  }

  let lastCallTimestamp = Date.now(); // should switch to perf
  loopedCB(repeat);
}

function throttlePoll(polledCb, options = {}) {
  let delay = 250; // ms
  let maxOutstanding = 5;
  let recovery = "immediate"; // what to do when throttled (immediately make a call after resolving one then resume polling, or continue polling at a fixed rate regardless)

  if (typeof options === 'number') {
    delay = options;
  } else {
    delay = options.hasOwnProperty("delay") ? options.delay : delay;
    maxOutstanding = options.hasOwnProperty("maxOutstanding") ? options.maxOutstanding : maxOutstanding;
    recovery = options.hasOwnProperty("recovery") ? options.recovery : recovery;
    // have a backoff option, which dictates if and how the delay evolves when throttled, exponential, linear, jitter, etc., see https://cloud.google.com/architecture/rate-limiting-strategies-techniques#client-side_strategies
  }

  let outstanding = 0;
  let throttled = false;
  let killed = false;

  const resolve = () => {
    if (throttled) {
      throttled = false;

      if (!killed && recovery === "immediate") {
        poll(); // continue polling
        polledCb(resolve); // immediately
        return;
      }
    }

    outstanding--;
  };

  function poll() { // start polling after the delay
    setTimeout(() => { // less accurate than with an interval
      if (killed) { return; }

      if (outstanding < maxOutstanding) {
        throttled = false;
        outstanding++;
        poll();
        polledCb(resolve);
      } else {
        throttled = true;
        if (recovery !== "immediate") {
          poll(); // we continue polling regardless
        }
        console.warn("too many outstanding polling calls (remember to resolve() them).");
      }
    }, delay);
  }

  poll();
  polledCb(resolve);

  return () => { // kill
    killed = true;
  };
}

function isArraysEqual(a, b) {
  // if length is not equal
  if(a.length != b.length)
    return false;
  else
  {
  // comparing each element of array
    for(let i = 0;i < a.length;i++)
      if(a[i] != b[i])
        return false;
    return true;
  }
}

function getPermutationsWithRepetition(total) {
  const holdingArr = [];
  const options = [1, -1];
  const recursiveABC = function(singleSolution) {
    if (singleSolution.length > total - 1) {
      holdingArr.push(singleSolution);
      return;
    }
    for (let i = 0; i < options.length; i++) {
      recursiveABC(singleSolution.concat([options[i]]));
    }
  };
  recursiveABC([]);
  return holdingArr;
}


function getAxisIconFromType(axisType) {
  if (['belt', 'enclosed_timing_belt'].includes(axisType)) {
    return 'icon-belt-actuator';
  }
  else if (['rack_and_pinion', 'rack_and_pinion_v2', 'belt_rack'].includes(axisType)) {
    return 'icon-rack-andpinion';
  }
  else if (['ball_screw', 'enclosed_ball_screw', 'enclosed_lead_screw'].includes(axisType)) {
    return 'icon-ballscrew';
  }
  else if (['indexer', 'indexer_v2'].includes(axisType)){
    return 'icon-rotary-indexer';
  }
  else if (['electric_cylinder'].includes(axisType)){
    return 'icon-electric-actuator';
  }
  else if(['belt_conveyor', 'roller_conveyor', 'heavy_duty_roller_conveyor'].includes(axisType)){
    return 'icon-conveyor';
  }
  else if(['pneumatic', 'pneumatic_bag_gripper'].includes(axisType)){
    return 'icon-pneumatic'; // TODO : verify that it is the right icon
  }
  else {
    return 'icon-axis';
  }
}


export default {
  punctuate,
  capitalize,
  loop,
  throttlePoll,
  isArraysEqual,
  getPermutationsWithRepetition,
  getAxisIconFromType,            // FIXME: this is a copy
  getAxisNumberFromColor,         // FIXME: this is a copy
  convert,                        // FIXME: this is a copy
};
